import { ref, watch } from '@vue/composition-api'

const COOKIE_KEY = 'tutoria-mode'
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60 // 1 ano em segundos

const showTutorIA = ref(false)
const tutorIAMode = ref('modal')

// Função para obter o domínio do cookie
const getCookieDomain = () => {
  if (typeof window === 'undefined') return ''
  
  const appDomain = process.env.VUE_APP_DOMAIN || process.env.APP_DOMAIN || 'localhost'
  
  // Se for localhost, não usar domínio
  if (appDomain === 'localhost' || appDomain.includes('127.0.0.1')) {
    return ''
  }
  
  return `.${appDomain}`
}

// Função para ler cookie
const getCookie = (name) => {
  if (typeof window === 'undefined') return null
  
  const cookies = document.cookie.split(';')
  for (const cookie of cookies) {
    const [key, value] = cookie.trim().split('=')
    if (key === name) {
      return decodeURIComponent(value)
    }
  }
  return null
}

// Função para salvar cookie
const setCookie = (name, value, domain) => {
  if (typeof window === 'undefined') return
  
  const domainStr = domain ? `; domain=${domain}` : ''
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${COOKIE_MAX_AGE}; path=/${domainStr}; SameSite=Lax`
}

// Carregar preferência do cookie
if (typeof window !== 'undefined') {
  const savedMode = getCookie(COOKIE_KEY)
  if (savedMode === 'modal' || savedMode === 'floating') {
    tutorIAMode.value = savedMode
  }
}

export function useTutorIA() {
  const openTutorIA = () => {
    showTutorIA.value = true
  }

  const closeTutorIA = () => {
    showTutorIA.value = false
  }

  const toggleTutorIA = () => {
    showTutorIA.value = !showTutorIA.value
  }

  const toggleMode = () => {
    console.log('🔄 toggleMode ANTES - mode:', tutorIAMode.value, 'visible:', showTutorIA.value)
    tutorIAMode.value = tutorIAMode.value === 'modal' ? 'floating' : 'modal'
    console.log('🔄 toggleMode DEPOIS - mode:', tutorIAMode.value, 'visible:', showTutorIA.value)
    
    // Salvar no cookie
    if (typeof window !== 'undefined') {
      const domain = getCookieDomain()
      setCookie(COOKIE_KEY, tutorIAMode.value, domain)
      console.log('🍪 Cookie salvo:', tutorIAMode.value)
    }
  }

  const setMode = (mode) => {
    tutorIAMode.value = mode
    
    // Salvar no cookie
    if (typeof window !== 'undefined') {
      const domain = getCookieDomain()
      setCookie(COOKIE_KEY, mode, domain)
    }
  }

  // Controlar overflow do body apenas quando em modo modal
  if (typeof window !== 'undefined') {
    watch([showTutorIA, tutorIAMode], ([isVisible, mode]) => {
      if (mode === 'modal') {
        document.body.style.overflow = isVisible ? 'hidden' : ''
      } else {
        document.body.style.overflow = ''
      }
    })
  }

  return {
    showTutorIA,
    tutorIAMode,
    openTutorIA,
    closeTutorIA,
    toggleTutorIA,
    toggleMode,
    setMode
  }
}
